(function($, Drupal) {
  'use strict';

  Drupal.behaviors.navigation = {
    attach: function(context, settings) {
      function focusTrap(element) {
        let $tabbable = element.find('button, a').filter(':visible');
        let $first_tabbable = $tabbable.first();
        let $last_tabbable = $tabbable.last();

        // Set focus on first input
        $first_tabbable.focus();

        // Redirect last tab to first input
        $last_tabbable.on('keydown', function(e) {
          if ((e.which === 9 && !e.shiftKey)) {
            e.preventDefault();
            $first_tabbable.focus();
          }
        });

        // Redirect first shift+tab to last input
        $first_tabbable.on('keydown', function(e) {
          if ((e.which === 9 && e.shiftKey)) {
            e.preventDefault();
            $last_tabbable.focus();
          }
        });
      }

      let $html,
          $body,
          $header,
          $header_menus,
          $mobile_nav_trigger,
          $dropdown_triggers,
          $current_dropdown,
          $dropdown_menu,
          $submenu_back;

      $html = $('html', context);
      $body = $('body', context);
      $header = $('#page-header', context);
      $header_menus = $('.header-menus', context);
      $mobile_nav_trigger = $('#js-nav-toggle', context);
      $dropdown_triggers = $('.dropdown-toggle', context);


      function setExpanded(current_dropdown) {
        $dropdown_triggers.not(current_dropdown).attr('aria-expanded', false);
        if (current_dropdown.hasClass('show')) {
          current_dropdown.attr('aria-expanded', true);
        }
        else {
          current_dropdown.attr('aria-expanded', false);
        }
      }

      once('add-show-more', '#js-nav-toggle', context).forEach((element) => {
        $(element).on('click', function() {
          console.log('Show me more');
          $mobile_nav_trigger.toggleClass('open');
          $('.header-menus').slideToggle(300);
          $html.toggleClass('no-scroll');
          $body.toggleClass('no-scroll');
          focusTrap($header);

          if (!$mobile_nav_trigger.hasClass('open')) {
            setTimeout(() => {
              if ($(window).width() < 992) {
                $('.region-header-nav li.active-trail .dropdown-toggle:not(.show)').trigger('click');
              }
            }, 300);
          }
        });
      });

      once('dropdown-trigger-click', '.dropdown-toggle', context).forEach((element) => {
        $(element).on('click', function() {
          $header_menus.addClass('covered');
          $current_dropdown = $(this);
          $dropdown_menu = $('#' + $current_dropdown.next().attr('id'));
          $dropdown_triggers.not($current_dropdown).removeClass('show');
          $dropdown_triggers.not($current_dropdown).next().removeClass('show');
          setTimeout(() => {
            $dropdown_triggers.not($current_dropdown).next().removeClass('prep-show');
          }, 300);

          $current_dropdown.toggleClass('show');
          if ($current_dropdown.hasClass('show')) {
            $dropdown_menu.addClass('prep-show');
            setTimeout(() => {
              $dropdown_menu.addClass('show');
            }, 10);
          }
          else {
            $dropdown_menu.removeClass('show');
          }
          setExpanded($current_dropdown);

          // Close if click outside of dropdown on desktop
          $(document).mouseup(function(e) {
            if ($(window).width() > 992 &&
              $(e.target).closest('.submenu-wrapper').length === 0 &&
              $(e.target).closest('.menu-item').length === 0) {
              $current_dropdown.removeClass('show');
              setExpanded($current_dropdown);
              $dropdown_menu.removeClass('show');
              setTimeout(() => {
                $dropdown_menu.removeClass('prep-show');
              }, 300);
            }
          });
        });
      });

      // Reorder elements in header for mobile devices to maintain tab order
      once('dropdown-back-click', '.dropdown-toggle-back', context).forEach((element) => {
        $(element).on('click', function() {
          $header_menus.removeClass('covered');
          $submenu_back = $(this).closest('.prep-show');
          $submenu_back.removeClass('show');
          setTimeout(() => {
            $submenu_back.removeClass('prep-show');
          }, 300);
          $dropdown_triggers.attr('aria-expanded', false);
          $dropdown_triggers.removeClass('show');
        });
      });

      // if ($(window).width() < 992) {
      //   $('.region-header-utility').first().insertAfter($('.region-header-nav').first());
      // }

      $(window).resize(function() {
        $dropdown_triggers.removeClass('show');
        $dropdown_triggers.next().removeClass('show');
        setTimeout(() => {
          $dropdown_triggers.next().removeClass('prep-show');
        }, 300);
        setExpanded($dropdown_triggers);

        // if (!window.orientation > 1) {
        //   if ($(window).width() < 992) {
        //     $('.region-header-utility').first().insertAfter($('.region-header-nav').first());
        //   }
        //   else {
        //     $('.region-header-utility').first().insertBefore($('.region-header-nav').first());
        //   }
        // }
      });

      $(document).ready(function() {
        $('#edit-keys').attr('placeholder', 'Search');
        if ($(window).width() < 992) {
          $('.region-header-nav li.active-trail .dropdown-toggle').trigger('click');
        }
      });

      // should start at 0
      if ($(window).width() > 992) {
        let $position = $(window).scrollTop();
        $(window).scroll(function() {
          let scroll = $(window).scrollTop();
          if (scroll > $position && !$('#page-header').hasClass('tucked') && $(window).scrollTop() > 100) {
            $('#page-header').addClass('tucked');
          }
          else if (scroll < $position && $('#page-header').hasClass('tucked')) {
            $('#page-header').removeClass('tucked');
          }
          $position = scroll;
        });
      }
    }
  };
})(jQuery, Drupal);
